import { useTheme } from '@/hooks/use-theme';
import markOffWhite from '@/assets/branding/mark-off-white.png';
import markOffBlack from '@/assets/branding/mark-off-black.png';
import markBlue from '@/assets/branding/mark-blue.png';
import markGreen from '@/assets/branding/mark-green.png';
import markAlertOrange from '@/assets/branding/mark-alert-orange.png';
import markAlertRed from '@/assets/branding/mark-alert-red.png';
import markPeppermint from '@/assets/branding/mark-peppermint.png';

// The manor mark ships as pre-colored raster art (one PNG per brand tone),
// so we select a variant rather than tinting an inline SVG. `auto` follows
// the resolved theme (off-white on dark chrome, off-black on light).
export type MarkTone =
  | 'auto'
  | 'off-white'
  | 'off-black'
  | 'blue'
  | 'green'
  | 'alert-orange'
  | 'alert-red'
  | 'peppermint';

const SRC: Record<Exclude<MarkTone, 'auto'>, string> = {
  'off-white': markOffWhite,
  'off-black': markOffBlack,
  blue: markBlue,
  green: markGreen,
  'alert-orange': markAlertOrange,
  'alert-red': markAlertRed,
  peppermint: markPeppermint,
};

interface ManorMarkProps {
  tone?: MarkTone;
  className?: string;
  /** Decorative by default; <Logo> and callers provide the accessible name. */
  alt?: string;
}

export function ManorMark({ tone = 'auto', className, alt = '' }: ManorMarkProps) {
  const { resolvedTheme } = useTheme();
  const resolvedTone = tone === 'auto' ? (resolvedTheme === 'dark' ? 'off-white' : 'off-black') : tone;
  return <img src={SRC[resolvedTone]} alt={alt} className={className} aria-hidden={alt === '' || undefined} />;
}
